<template>
    <div class="centerPage">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
            <el-breadcrumb-item><a href="javascript:void(0);" @click="$router.back(-1)" class="aHref">咨询管理</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="formUserInfo">
            <div class="cnHomeTabsItem flex">
                <div class="avatar img" v-if="userHeadImgPath" :style="'backgroundImage: url('+userHeadImgPath+')'"></div>
                <div class="avatar img default-user-avatar" v-else></div>
                <div class="rightHome">
                    <div class="flex">
                        <span class="com">预约人：{{appointData.realName}}</span>
                        <span class="number">预约号：{{appointData.medicalNo}}</span>
                    </div>
                    <p>
                        <span class="time">预约时间：{{appointData.appointDate | timeFilter(appointData.appointTimeSlot)}}</span>
                    </p>
                    <div class="flex">
                        <span class="com">咨询方式：{{appointData.consultMode===1?'语音':'视频'}}</span>
                        <span class="com">咨询费用：<span class="cost">￥{{appointData.payAmount}}</span></span>
                        <span class="com cost">
                                已通话
                            </span>
                        <el-button size="mini" class="solid">
                            已咨询
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="cnHomeTabsItem ">
                <p class="infoTit">预约信息</p>
                <div class="appointInfo">
                    <p><span>预约时间：</span>{{appointData.appointDate | timeFilter(appointData.appointTimeSlot)}}</p>
                    <p><span>咨询方式：</span>{{appointData.consultMode===1?'语音':'视频'}}</p>
                    <div class="flex">
                        <p><span>姓名：</span>{{appointData.realName}}</p>
                        <p><span>年龄：</span>{{appointData.age}}</p>
                        <p><span>性别：</span>{{appointData.gender==1?'男': appointData.gender==0?'女':'-'}}</p>
                    </div>
                    <div class="flex">
                        <p><span>所在城市：</span>{{appointData.abodeCity}}</p>
                        <p><span>职业：</span>{{appointData.occupation}}</p>
                    </div>
                    <p class="text"><span>问题描述：</span><span>{{appointData.problemDesc}}</span></p>
                    <p class="text"><span>期望效果：</span><span>{{appointData.expectEffect}}</span></p>
                </div>
            </div>
            <div class="cnHomeTabsItem ">
                <p class="infoTit">咨询建议</p>
                <div class="appointInfo">
                    <p><span>咨询建议：</span>{{recordData.result}}</p>
                    <p class="text"><span>建议：</span><span>{{recordData.adviseWritten}}</span></p>
                    <p><span>依从性：</span>{{recordData.patientCompliance==1?'完全':recordData.patientCompliance==2?'部分':'完全不'}}依从</p>
                    <p><span>医院推荐：</span>{{recordData.adviseHospital}}</p>
                    <p><span>医师推荐：</span>{{recordData.adviseDoctor}}</p>
                    <p><span>用药建议：</span>{{recordData.adviseDrug}}</p>
                    <p><span>备注：</span>{{recordData.doctorRemark}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import commonjs from "../../api/common";
    export default {
        name: "recordDetail",
        data() {
            return {
                //数据:
                userHeadImgPath: '',//预约人头像
                appointData: {},//预约数据
                recordData: {},//分析数据
            }
        },
        mounted() {
            // this.getAppointMethod();//查找预约信息
            this.getRecordMethod();//查找分析结果
        },
        methods: {
            getRecordMethod() {
                let that = this;
                this.$ajax
                    .get(commonjs.api.doctor.medicalRecord.recordDoctorByMedical.replace("{medicalNo}",that.$route.query.id))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.recordData = res.data.data.medicalRecord;
                            that.appointData = res.data.data.medicalAppoint;
                            // 用户头像可能为空, 此时authUser is null
                            if(res.data.data.authUser){
                                that.userHeadImgPath = res.data.data.authUser.headImgPath;
                            }
                        } else {
                          that.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
        },
        filters: {
            timeFilter: function (date,slot) {
                //原始数据2020-08-24T14:53:41
                //slot:20
                date = new Date(date).Format('yyyy年MM月dd日');
                return date + slot + '至' + (slot+1) + '时';
            }

        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.centerPage {
    display: block;

    .orange {
        color: #FFAB37;
    }

    .cnHomeTabsItem .rightHome .flex {
        justify-content: inherit;

        span.com {
            width: 30%;
        }

        .number {
            text-align: right;
            width: 40%;
        }
    }
}
.default-user-avatar {
    background: url("/static/default_imgs/avatar.png") no-repeat;
    background-size: contain;
}
</style>